import { render, staticRenderFns } from "./DefaultLoader.vue?vue&type=template&id=ca8980bc&"
import script from "./DefaultLoader.vue?vue&type=script&lang=js&"
export * from "./DefaultLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports